import {
    GetList,
    PostIntegration,
    DeleteIntegration,
    GetIntegration,
    PutIntegration,
    ChangeIntegrationStatus,
    CreateToken,
} from '@src/services/integration'
import { getSavedState } from '@/src/utils/localStorage'

export const state = {
    listIntegrations: [],
}

export const getters = {
    totalList(state) {
        return state.listIntegrations.data
            ? state.listIntegrations.data.totalItemCount
            : 0
    },
}

export const mutations = {
    FETCH_LIST(state, integrations) {
        state.listIntegrations = integrations
    },
    SET_STATE(state, payload) {
        if (state.listIntegrations.data) {
            state.listIntegrations.data.items.find(({ publicId }) => {
                return publicId === payload.publicId
            }).status = payload.status
        }
    },
    UPDATE_PLAN(state, payload) {
        state.integrationsFormState = payload
    },
    NEXT_PAGE_LIST(state, list) {
        list.forEach((team) => {
            state.listIntegrations.data.items.push(team)
        })
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetList(locationPublicId, parameters)

        if (resp && resp.status === 200) {
            commit('FETCH_LIST', resp.data)
        }
    },
    async getIntegration({ _ }, parameters) {
        const resp = await GetIntegration(parameters)
        return resp
    },
    async saveNewIntegration({ _ }, parameters) {
        const resp = await PostIntegration(parameters)
        return resp
    },
    async editIntegration({ _ }, params) {
        const resp = await PutIntegration(params)
        return resp
    },
    async delete({ dispatch }, data) {
        const resp = await DeleteIntegration(data)

        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async toggleStatus(_, data) {
        const resp = await ChangeIntegrationStatus(data)
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
    async createToken(_, params) {
        const resp = await CreateToken(params)
        return resp
    },
}
